var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',[_c('rabbey-toolbox',{attrs:{"filterables":true},on:{"filter-search":_vm.filterSearch}},[_c('div',{staticClass:"mr-5"},[_c('yearcomponent',{staticClass:"box-item",on:{"change":_vm.handler_year}})],1)]),_c('rabbey-table2',{attrs:{"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }